export default [
  {
    path: "/parking-permit",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    children: [
      {
        path: ":id",
        name: "Parking Permit",
        component: () => import("@/views/ParkingPermit/ParkingPermit.vue")
      },
      {
        path: "confirmation/:orderId",
        name: "Parking Permit Confirmation",
        props: true,
        component: () => import("@/views/ParkingPermit/ParkingPermit.vue"),
        meta: { confirmation: true, failure: false }
      },
      {
        path: "failure/:orderId",
        name: "Parking Permit Failure",
        component: () => import("@/views/ParkingPermit/ParkingPermit.vue"),
        props: true,
        meta: { confirmation: false, failure: true }
      }
    ]
  }
];
